<template>
  <v-card elevation="8" class="pa-4">
    <v-btn color="#FFD600" @click="agregarMesaDorada" class="mb-4">
      <v-icon left>mdi-plus</v-icon>
      Sección Dorada
    </v-btn>
    <v-row>
      <v-col cols="auto" v-for="(mesa, index) in mesasDorado" :key="'dorado-' + index" class="d-flex justify-center">
        <v-card @click="abrirDialogo(index, 'dorado')" class="d-flex align-center justify-center"
          style="width: 100px; height: 100px; padding: 0; cursor: pointer" elevation="4">
          <div class="mesa-numero">
            {{ mesa.numero || index + 1 }}
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-card>

  <v-divider class="my-4" />

  <v-card elevation="8" class="pa-4">
    <v-btn color="#455A64" @click="agregarMesaDiamante" class="mb-4">
      <v-icon left>mdi-plus</v-icon>
      Sección Diamante
    </v-btn>
    <v-row>
      <v-col cols="auto" v-for="(mesa, index) in mesasDiamante" :key="'diamante-' + index" class="d-flex justify-center">
        <v-card @click="abrirDialogo(index, 'diamante')" class="d-flex align-center justify-center"
          style="width: 100px; height: 100px; padding: 0; cursor: pointer" elevation="4">
          <div class="mesa-numero">
            {{ mesa.numero || index + 1 }}
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-card>

  <!-- Modal de edición -->
  <v-dialog v-model="dialog" max-width="600">
    <v-card>
      <v-card-title>Editar Mesa {{ mesaSeleccionada?.numero || mesaSeleccionadaIndex + 1 }}</v-card-title>
      <v-card-text>
        <v-text-field
          v-for="(nombre, i) in mesaSeleccionada?.sillas"
          :key="i"
          v-model="mesaSeleccionada.sillas[i]"
          :label="`Silla ${i + 1}`"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="dialog = false">Cancelar</v-btn>
        <v-btn text color="primary" @click="guardarCambios">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref } from 'vue'

const mesasDorado = ref([])
const mesasDiamante = ref([])

const dialog = ref(false)
const mesaSeleccionada = ref(null)
const mesaSeleccionadaIndex = ref(null)
const mesaSeleccionadaSeccion = ref(null)

const agregarMesaDorada = () => {
  mesasDorado.value.push({
    numero: mesasDorado.value.length + 1,
    sillas: Array(10).fill('')
  })
}

const agregarMesaDiamante = () => {
  mesasDiamante.value.push({
    numero: mesasDiamante.value.length + 1,
    sillas: Array(10).fill('')
  })
}

const abrirDialogo = (index, seccion) => {
  mesaSeleccionadaIndex.value = index
  mesaSeleccionadaSeccion.value = seccion
  const mesaLista = seccion === 'dorado' ? mesasDorado : mesasDiamante
  mesaSeleccionada.value = JSON.parse(JSON.stringify(mesaLista.value[index]))
  dialog.value = true
}

const guardarCambios = () => {
  const target = mesaSeleccionadaSeccion.value === 'dorado' ? mesasDorado : mesasDiamante
  target.value[mesaSeleccionadaIndex.value] = {
    ...mesaSeleccionada.value,
    numero: mesaSeleccionada.value.numero || mesaSeleccionadaIndex.value + 1
  }
  dialog.value = false
}
</script>

<style scoped>
.mesa-numero {
  font-weight: bold;
  font-size: 1.2rem;
  text-align: center;
}
</style>
